<template>
    <div class="cancelplan-root">
        <div class="root-container">
            <div class="content-top">
                <h1>{{ $t('cancel_complete.title', {
                    planname
                }) }}</h1>
            </div>
            <steps :stepsData="stepsData" :stepsIndex="highLight" class="step-com"></steps>

            <div class="step-two">
                <div class="middle-imme">
                    <p class="package plan-imme">{{$t('cancel_complete.plan_status')}}</p>
                    <p class="imme-time">
                        {{$t('cancel_complete.plan_decf')}} <span>{{$t('cancel_complete.plan_decs')}}</span>{{$t('cancel_complete.plan_dect')}}
                    </p>
                </div>
                <div class="middle-text">
                    <p v-html="$t('cancel_complete.notice', lang, {
                        link: config.support_team
                    })"></p>
                </div>

                <div class="make-sureok">
                    <reo-common-button
                        :label="$t('cancel_complete.sure_ok')"
                        @click="handleNext"
                    />
                </div>
            </div>
        </div>
    </div>

</template>

<script lang="ts">
import Vue from 'vue';
import steps from '@/basic/Steps.vue';
import nprogress from 'nprogress';
import { config } from 'CONFIG';
import { isApp } from '@/utils/business';
import { callAppApi } from '@reolink-web/app-sdk';

export default Vue.extend({

    components: {

        steps
    },

    data () {

        return {

            planname: this.$route.query.plan_name,
            type: this.$route.query.type,
            stepsData: [{
                name: '1',
                value: 1
            },
            {
                name: '2',
                value: 2
            }],
            config

        };

    },

    computed: {

        highLight (): number {

            let { path } = this.$route;
            return path === '/user/cancel-plan/complete/' ? 1 : 0;

        },
        dashBoardLink (): string {

            return this.type === 'traffic' ? `/user/dashboard/?mode=view` : '/user/dashboard/';

        },
        lang(): string {

            return this.$store.getters.lang;

        }

    },

    mounted () {

        nprogress.done();

    },

    methods: {

        async handleNext () {

            if ( isApp ) {

                await callAppApi( 'finishPage', {});

            } else {

                await this.$router.push( this.dashBoardLink );

            }

        }

    }

});
</script>

<style lang="less" scoped>
    .cancelplan-root {
        margin: auto;
        max-width: 1200px;
        background-color:@bg_02;
        padding: 30px 0;
        @media @snapeak_mobile{
           background-color: transparent;
        }
        .root-container{
           width: 765px;
           margin: auto;
        }
        .content-top {
            text-align: center;
            h1 {
                margin: 0.6rem 0 0.55rem 0;
                font-weight: 700;
                font-size: 0.36rem;
            }
        }

    }
    .middle-imme{
        border-bottom: solid 0.01rem @line;
        padding:0.42rem 0 0.4rem 0;
        margin-bottom: 0.2rem;
        .imme-time{
            font-weight: 500;
            font-size: 0.16rem;
            span{
                font-weight: 600;
            }
        }
    }
    .make-sureok{
        margin:0.7rem 0;
        text-align: center;
    }
    .package.plan-imme{
        display: block;
        margin-bottom:0.2rem;
        font-size: 0.2rem;
        font-weight: 700;
    }
    .package {
        font-weight: 700;
        font-size: 0.2rem;
        margin-bottom: 0.2rem;
    }
    .middle-text {
        p {
            font-size: 0.16rem;
            font-weight: 400;
        a {
            color: @theme;
            cursor: pointer;
        }
      }
    }

    @media @snapeak_mobile{
        .cancelplan-root {
            padding: 0 15px;
            box-sizing: border-box;
            .root-container{
                width: 100%;
            }
            .content-top {
                h1 {
                    margin: 1rem 0 0.6rem 0;
                    font-weight: 500;
                    font-size: 0.52rem;
                }
            }
            .step-com{
                .steps-item{
                    width:0.44rem;
                    padding: 0 0.44rem;
                }
            }
        }
        .middle-imme{
            border:none;
            padding: 0;
            margin:0;
            .imme-time{
                display: none;
            }
        }
        .make-sureok{
            margin:0.6rem 0 1rem 0;
            display: flex;
            flex-direction: column;
            .ui-button {
                width:100%;
                box-sizing: border-box;
            }
        }
        .package.plan-imme{
            display: block;
            margin:0.6rem 0 0.3rem 0;
            font-size: 0.32rem;
            font-weight: 500;
        }
        .package {
            font-weight: 500;
            font-size: 0.36rem;
            margin-bottom: 0.3rem;
        }
        .middle-text {
            p {
                font-size: 0.24rem;
                font-weight: 400;
                a {
                    color: @theme;
                    cursor: pointer;
                    font-weight: 400;
                }
            }
        }

    }
</style>
